export default __webpack_public_path__ + "static/media/5.8c888c19.png";